import React, { useState } from "react";
import Styles from "./LogoEdit.module.css";
import { NumberInput } from "../../../../../../Components";
import { EC_Modal } from "../../../../../../UiComponents";
import { Button } from "../../../../../../Components";
import { useEffect } from "react";
const LogoEdit = ({
  logoEditOpen,
  setLogoEditOpen,
  position,
  updateLogo,
  selectedLogo,
  removeLogo,
}) => {
  const [scale, setScale] = useState(selectedLogo?.scale);
  const [offset_x, setOffSetX] = useState(selectedLogo?.offset_x);
  const [offset_y, setOffSetY] = useState(selectedLogo?.offset_y);

  useEffect(() => {
    setScale(selectedLogo?.scale || 80);
    setOffSetX(selectedLogo?.offset_x || 0);
    setOffSetY(selectedLogo?.offset_y || 0);
  }, [selectedLogo?.scale, selectedLogo?.offset_x, selectedLogo?.offset_y]);
  return (
    <EC_Modal
      isOpen={logoEditOpen}
      closeModal={() => {
        if (
          scale !== selectedLogo?.scale ||
          offset_x !== selectedLogo?.offset_x ||
          offset_y !== selectedLogo?.offset_y
        )
          updateLogo({
            scale: parseInt(scale),
            offset_x: parseInt(offset_x),
            offset_y: parseInt(offset_y),
          });
        setLogoEditOpen(false);
      }}
      styleLeft={position?.left}
      styleTop={position?.top}
      title="Edit Logo"
      styleUnit={position?.unit}
    >
      <div className={Styles.MainLogoEditDIv}>
        <div className={Styles.mainContainer}>
          <div className={Styles.labelBox}>
            <label>Scale</label>
          </div>
          <div className={Styles.InputBox}>
            <NumberInput
              postLabel="%"
              value={scale}
              min={50}
              max={100}
              onChange={setScale}
            />
          </div>
        </div>
        <div className={Styles.mainContainer}>
          <div className={Styles.labelBox}>
            <label>Position X</label>
          </div>
          <div className={Styles.InputBox}>
            <NumberInput
              postLabel="px"
              value={offset_x}
              min={-100}
              max={100}
              onChange={setOffSetX}
            />
          </div>
        </div>
        <div className={Styles.mainContainer}>
          <div className={Styles.labelBox}>
            <label>Position Y</label>
          </div>
          <div className={Styles.InputBox}>
            <NumberInput
              postLabel="px"
              value={offset_y}
              min={-100}
              max={100}
              onChange={setOffSetY}
            />
          </div>
        </div>
        <div className="flex justify-center p-2">
          <div
           className={Styles.LogoRemove}
            onClick={() => {
              removeLogo();
              setLogoEditOpen(false);
            }}
          >
            Remove
          </div>
        </div>
      </div>
    </EC_Modal>
  );
};

export default LogoEdit;
